import Person from 'assets/images/wholesaler/modal/modal-person-market.svg';
import Portal from 'components/portal';
import useSetWanted from 'components/modal/hooks/useSetWanted';

const AddWantedModal = ({
  showModal,
  setShowModal,
  title,
  city,
  state,
  app,
  guid,
}: IAddWantedModalProps) => {
  const {isLoading, mutate} = useSetWanted(setShowModal);
  return (
    <>
      {showModal && (
        <Portal>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none mx-8 ">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none  border border-primary">
                <div className="flex flex-col justify-center items-center p-5  rounded-t">
                  <img src={Person} alt="person" className=" -mt-12" />
                  <h3 className=" text-center text-primary mt-6">
                    تعیین سطح کیفیت محصول
                  </h3>
                </div>
                <div className="relative px-2 flex-auto">
                  <p className="my-1  leading-relaxed">
                    به یک نفر مشاور جهت تعیین سطح کیفیت محصول {` ${title} `}
                    {state
                      ? `در
                    محدوده
                      ${state},
                    `
                      : city
                      ? `${city}`
                      : ''}
                    نیاز دارم.
                  </p>
                </div>
                <div className="flex w-full px-2 py-4 ">
                  <button
                    className=" text-center py-4 rounded-md bg-primary text-white w-1/2"
                    onClick={() => {
                      const payload = {
                        post_guid: guid,
                        app: 'MARKET',
                      };
                      !isLoading && mutate(payload);
                    }}
                  >
                    ارسال درخواست
                  </button>
                  <button
                    className=" text-center py-4 rounded-md text-primary bg-white w-1/2 "
                    onClick={() => setShowModal(false)}
                  >
                    انصراف
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="opacity-25 fixed inset-0 z-40 bg-black -mx-3"
            onClick={() => setShowModal(false)}
          ></div>
        </Portal>
      )}
    </>
  );
};

export default AddWantedModal;
